import { useAuth } from "contexts/AuthContext";
export const getInternalLegalResearchRequest = async (bearer: string, id: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/internal-research-requests/${id}`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to fetch internal legal research request");
    }
    return response.json();
};

export const getInternalLegalResearchRequests = async (bearer: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/internal-research-requests/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to fetch internal legal research request");
    }
    return response.json();
};

export const getInternalLegalResearchRequestsByProsecutor = async (bearer: string, prosecutor_user_id: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/internal-research-requests/by-prosecutor/?prosecutor_user_id=${prosecutor_user_id}`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to fetch internal legal research requests by prosecutor");
    }
    return response.json();
};

export const getCommitteeLegalResearchRequestsByStakeholder = async (bearer: string, stakeholder_id: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-committee-requests/by-stackholder/?stackholder_id=${stakeholder_id}`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to fetch internal legal research request");
    }
    return response.json();
};
export const getCommitteeLegalResearchRequests = async (bearer: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-committee-requests/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to fetch internal legal research request");
    }
    return response.json();
};

export const createInternalLegalResearchRequest = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/internal-research-requests/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create internal legal research request");
    }
    return response.json();
};

export const updateInternalLegalResearchRequest = async (bearer: string, id: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/internal-research-requests/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create internal legal research request");
    }
    return response.json();
};

export const createLegalResearchCommitteReport = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-committee-reports/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create legal research committe report");
    }
    return response.json();
};

export const createLegalResearchRequest = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/legal-research-requests/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create legal research request");
    }
    return response.json();
};

export const createLegalResearchRequestCommittee = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-committee-requests/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create legal research request");
    }
    return response.json();
};
export const getLegalResearchRequestsByStakeHolder = async (bearer: string, stakeholder_id: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/legal-research-requests/by-stackholder/?stackholder_id=${stakeholder_id}`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
                "Content-Type": "application/json",
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        throw new Error("Failed to get legal research requests");
    }
    return response.json();
};
export const getLegalResearchRequests = async (bearer: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/legal-research-requests/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
                "Content-Type": "application/json",
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        throw new Error("Failed to get legal research requests");
    }
    return response.json();
};

export const getLegalResearchRequest = async (id: string, bearer: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/legal-research-requests/${id}`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
                "Content-Type": "application/json",
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to get legal research requests");
    }
    return response.json();
};

export const getCommitteeLegalResearchRequest = async (id: string, bearer: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-committee-requests/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
                "Content-Type": "application/json",
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to get legal research requests");
    }
    return response.json();
};

export const updateLegalResearchRequest = async (
    id: String,
    data: FormData,
    bearer: string
) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/legal-research-requests/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create legal research request");
    }
    return response.json();
};

export const updateLegalResearchRequestCommittee = async (
    id: String,
    data: FormData,
    bearer: string
) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-committee-requests/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create legal research request");
    }
    return response.json();
};



export const createDataCollectionEntry = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/data-collection-entries/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create data collector request");
    }
    return response.json();
};

export const createFeedback = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/legal-research-feedbacks/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create data collector request");
    }
    return response.json();
};

export const createRespondBackFeedback = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/respondback-feedbacks/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create respond back feedback request");
    }
    return response.json();
};

export const createLegalResearchData = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-files/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create respond back feedback request");
    }
    return response.json();
};

export const updateLegalResearchData = async (
    bearer: string,
    id: string,
    data: FormData
) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-files/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to update legal research data");
    }
    return response.json();
};

export const createLegalResearchTopics = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-topics/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create respond back feedback request");
    }
    return response.json();
};

export const updateLegalResearchTopic = async (bearer: string, id: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-topics/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create respond back feedback request");
    }
    return response.json();
};

export const deleteLegalResearchTopic = async (bearer: string, id: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-topics/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "DELETE",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create respond back feedback request");
    }
};

export const getMappedLegalResearchSummaries = async (): Promise<any[]> => {
    const response = await fetch(
        "https://test.research-api.oagb.et/api/legal_research/mapped-summary/",
        {
            method: "GET",
        }
    );
    if (!response.ok) {
        throw new Error("Failed to get legal research summaries");
    }
    return response.json();
};

export const getLegalResearchTopics = async (bearer: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-topics/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get research topic request");
    }
    return response.json();
};

export const createResearchTeam = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-teams/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create legal research Team");
    }
    return response.json();
};

export const updateResearchTeam = async (bearer: string, id: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-teams/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to update legal research Team");
    }
    return response.json();
};

